/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 04 2023
 **/

import { Theme, css } from "@emotion/react";
import styled from "@emotion/styled";

import { Row, Typography } from "@/frameworks/designStuff/components";

export const ShortDirectMessageWrap = styled(Row)<{ isChatFeature?: boolean; activeBackground?: boolean }>`
	position: relative;
	min-height: 32px;
	height: ${(isChatFeature) => (isChatFeature ? 40 : 32)}px;
	padding: 6px 0;
	background-color: ${({ theme, activeBackground }) =>
		activeBackground ? theme.colors.accent_00_100 : theme.colors.transparent};
	border-radius: 12px;
	&:hover {
		background: rgba(50, 51, 56, 0.08);
		border-radius: 12px;

		.icon__more {
			display: flex;
		}

		.icon__pin,
		.icon__new {
			display: none;
		}
	}
`;

export const shortDirectMessageContentCss = (theme: Theme) => css`
	color: ${theme.colors.neutral_50_100};
`;

export const ShortDirectMessageIconWrap = styled(Row)`
	position: absolute;
	right: 4px;
	width: 32px;
	height: 32px;

	.icon__more {
		display: none;
	}
`;

export const UserNameList = styled(Typography)`
	max-width: 80%;
`;
